import { StyledRow } from "App/global-style";
import {
  CoverageNeed,
  ProductCoverageName,
  ProductName,
} from "Store/akaAdvice/interfaces/CollectiveAdvice";

import { VALUE_TYPE } from "Components/NumberValue";
import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { isNotAllowed } from "Store/akaAdvice/interfaces/getters";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { FormikProps } from "formik";
import React from "react";
import { useAdviceIsLoading } from "../../../hooks/stateSelectors";
import { checkShouldPurchaseFromAdvisor } from "../../../utils";
import { AkaDiscreteSlider } from "../../AkaDiscreteSlider/AkaDiscreteSlider";
import { AkaAdvicePriceFormValues } from "../../interfaces";

const SLIDER_STEP = 100000;

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  need: CoverageNeed;
  recalculatePrice: (
    formValues: AkaAdvicePriceFormValues,
    specificProduct: ProductName,
  ) => void;
  setPriceIsChanging: (value: boolean) => void;
  adviceCard: any;
  lang: string;
}

export const IndividualDeathForm = ({
  formProps,
  need,
  recalculatePrice,
  setPriceIsChanging,
  adviceCard,
  lang,
}: Props): React.ReactElement | null => {
  const isAdvisor = useIsAdvisorSelector();
  const isLoading = useAdviceIsLoading();

  const shouldPurchaseFromAdvisor = checkShouldPurchaseFromAdvisor(
    isAdvisor,
    need,
    ProductCoverageName.DEATH,
  );

  if (isNotAllowed(need, ProductCoverageName.DEATH)) {
    return null;
  }

  return (
    <StyledRow className="AkaAdviceInsuranceForm">
      <AkaDiscreteSlider
        name="deathInsuredSumSlider"
        isAdvisor={isAdvisor}
        need={need}
        productCoverageName={ProductCoverageName.DEATH}
        step={SLIDER_STEP}
        adviceValueMarkLabel={
          shouldPurchaseFromAdvisor
            ? adviceCard.sliderValueMarker.maxAmount[lang]
            : adviceCard.sliderValueMarker.advicedAmount[lang]
        }
        valueType={VALUE_TYPE.NOK}
        disabled={isLoading}
        label={adviceCard.sliderValueMarker.advicedAmount[lang]}
        onChange={() => setPriceIsChanging(true)}
        onChangeCommitted={(_, value) =>
          recalculatePrice(
            {
              ...formProps.values,
              deathInsuredSumSlider: value,
            },
            INSURANCE_NAME_VALUE.DEATH,
          )
        }
        withLeeway
      />
    </StyledRow>
  );
};
